import { createFileRoute } from "@tanstack/react-router";
import WellmarkInsurance, { config } from "@/pages/WellmarkInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/wellmark-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Wellmark TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Wellmark Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Wellmark TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Wellmark Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/wellmark-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/wellmark-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WellmarkInsurance />;
}
